export default __webpack_public_path__ + "static/media/trr-drink-specialty-matchablossom.5d42c043.png";